import React from "react";
import cn from "classnames";
import withStyles from "components/with-styles";
import styles from "./styles/icon-button.css.js";
import MUIIconButton from "@material-ui/core/IconButton";

const IconButton = ({ classes, className, ...props }) => {
  return <MUIIconButton className={cn(classes.iconButton, className)} {...props} />;
};

IconButton.propTypes = {
  ...MUIIconButton.propTypes,
};

export default withStyles(styles)(IconButton);
